import { SET_CURRENT_HOLTER } from './holter.type'

export const setCurrentHolter = (data) => async (dispatch) => {
    dispatch({
        type: SET_CURRENT_HOLTER,
        payload: data,
    })
}
